// import {ReceiptLayout} from '../ReceiptLayouts/Model'
import BusinessUnit from '../BusinessUnits/Model';
var OperationLine = /** @class */ (function () {
    function OperationLine(props) {
        Object.assign(this, props);
        if (props.businessUnit) {
            this.businessUnit = new BusinessUnit(props.businessUnit);
        }
    }
    return OperationLine;
}());
export default OperationLine;



//////////////////
// WEBPACK FOOTER
// ./src/modules/OperationLines/Model.ts
// module id = 709
// module chunks = 0